import React, { useEffect } from "react";
import { ThemeContext } from "./ThemeContext";
import useStateWithLocalStorage from "../hooks/useStateWithLocalStorage";

function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [theme, setTheme] = useStateWithLocalStorage<"light" | "dark">(
    "theme",
    "light",
  );

  // Apply theme to document root whenever it changes.
  //
  // Both attributes matter. `data-theme` drives this app's own custom
  // properties in index.css; `data-bs-theme` is what Bootstrap 5.3 keys its
  // built-in dark palette off. Without the second one every Bootstrap token
  // (--bs-body-bg, --bs-emphasis-color, --bs-border-color, the form-select
  // chevron, the modal close button) keeps its light value in dark mode,
  // which is what left tables and dialogs rendering white-on-dark.
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    document.documentElement.setAttribute("data-bs-theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
  };

  const value = { theme, toggleTheme };

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
}

export default ThemeProvider;
